import { Input } from '@planuze/ui';
import { useEffect, useRef, useState } from 'react';
import { formatCents, parseCurrencyToCents } from '../../lib/currency.js';

interface Props {
  readonly value: number;
  readonly currency: string;
  readonly onChange: (cents: number) => void;
  readonly id?: string;
}

/* Input de moeda controlado: edita texto livre, normaliza p/ cents no blur (Math.round
   evita drift de float) e re-formata. O display é sincronizado com a prop `value`
   (prefill de edição, reset de form) — EXCETO enquanto o campo está focado, para não
   reformatar no meio da digitação (ADR-0697). Sem essa sync, o form popula o state
   DEPOIS do mount e o display ficava preso em "US$ 0,00" — e focar+desfocar o campo
   gravava 0 (perda de dado silenciosa no preço de assento extra). */
export function CurrencyInput({ value, currency, onChange, id }: Props) {
  const [display, setDisplay] = useState(() => formatCents(value, currency));
  const focused = useRef(false);

  useEffect(() => {
    if (!focused.current) {
      setDisplay(formatCents(value, currency));
    }
  }, [value, currency]);

  return (
    <Input
      id={id}
      value={display}
      onFocus={() => {
        focused.current = true;
      }}
      onChange={(e) => setDisplay(e.target.value)}
      onBlur={() => {
        focused.current = false;
        const cents = parseCurrencyToCents(display);
        onChange(cents);
        setDisplay(formatCents(cents, currency));
      }}
    />
  );
}
